import type { RichTextBlock } from '../../../../core/data-sources/content-components/types.js';

import { safeParse } from './safeParse.js';

export interface Faq {
  question: RichTextBlock;
  answers: RichTextBlock[];
}

export function buildFaq(faq: string): Faq[] | null {
  const parsed = safeParse(faq) as RichTextBlock[];
  if (typeof parsed === 'string') return null;

  const faqs: Faq[] = [];
  let currentQuestion: RichTextBlock | null = null;
  let currentAnswers: RichTextBlock[] = [];

  parsed.forEach((block, index) => {
    if ('text' in block && block.text.value.includes('?')) {
      if (currentQuestion) {
        faqs.push({ question: currentQuestion, answers: [...currentAnswers] });
        currentAnswers = [];
      }
      currentQuestion = block;
    } else if (currentQuestion) {
      currentAnswers.push(block);
      if (index === parsed.length - 1) {
        faqs.push({ question: currentQuestion, answers: [...currentAnswers] });
      }
    }
  });

  return faqs;
}
